import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/
export default function (props: IconsProps) {
  return (
    <Icons viewBox="0 0 64 64" {...props}>
      <path d="M.613 60.114a2.014 2.014 0 1 0 2.848 2.849L63.41 3.438A2.014 2.014 0 0 0 60.562.589L.613 60.114z" />
    </Icons>
  );
}
